import { render, staticRenderFns } from "./LandingSwap.vue?vue&type=template&id=0e540b9c&"
import script from "./LandingSwap.vue?vue&type=script&lang=js&"
export * from "./LandingSwap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports